import { defineMessages } from "react-intl";

// Headers match the mobile Device Permissions screen, using its iOS wording.
export default defineMessages({
  backgroundRefresh: {
    id: "reports.permissionsReport.table.column.backgroundRefresh",
    defaultMessage: "Background Refresh",
    description: "Permissions Report column - Background Refresh permission",
  },
  backgroundRefreshInfo: {
    id: "reports.permissionsReport.table.column.backgroundRefresh.info",
    defaultMessage:
      "Lets the app keep working when it isn't open. Mileage Tracker uses it to keep recording drives, and offline mode uses it to sync. iPhone and iPad only.",
    description: "Permissions Report column header tooltip - what Background Refresh is for",
  },
  device: {
    id: "reports.permissionsReport.table.column.device",
    defaultMessage: "Device",
    description: "Permissions Report column - the device a rep reported from",
  },
  location: {
    id: "reports.permissionsReport.table.column.location",
    defaultMessage: "Location",
    description: "Permissions Report column - Location permission",
  },
  locationInfo: {
    id: "reports.permissionsReport.table.column.location.info",
    defaultMessage:
      "Lets the app see where the rep is. Required for check-ins. Mileage Tracker also needs it set to Always.",
    description: "Permissions Report column header tooltip - what Location is for",
  },
  motion: {
    id: "reports.permissionsReport.table.column.motion",
    defaultMessage: "Motion",
    description: "Permissions Report column - Motion permission",
  },
  motionInfo: {
    id: "reports.permissionsReport.table.column.motion.info",
    defaultMessage:
      "Lets Mileage Tracker tell when a drive starts and stops. Only used by Mileage Tracker.",
    description: "Permissions Report column header tooltip - what Motion is for",
  },
  name: {
    id: "reports.permissionsReport.table.column.name",
    defaultMessage: "Name",
    description: "Permissions Report column - rep name",
  },
  notifications: {
    id: "reports.permissionsReport.table.column.notifications",
    defaultMessage: "Notifications",
    description: "Permissions Report column - Notifications permission",
  },
  notificationsInfo: {
    id: "reports.permissionsReport.table.column.notifications.info",
    defaultMessage: "Lets the app send the rep reminders and alerts. Recommended for every rep.",
    description: "Permissions Report column header tooltip - what Notifications are for",
  },
  preciseLocation: {
    id: "reports.permissionsReport.table.column.preciseLocation",
    defaultMessage: "Precise Location",
    description: "Permissions Report column - Precise Location permission",
  },
  preciseLocationInfo: {
    id: "reports.permissionsReport.table.column.preciseLocation.info",
    defaultMessage:
      "Uses the phone's exact location instead of an approximate area. Recommended for every rep to improve check-in accuracy.",
    description: "Permissions Report column header tooltip - what Precise Location is for",
  },
  team: {
    id: "reports.permissionsReport.table.column.team",
    defaultMessage: "Team",
    description: "Permissions Report column - the rep's team",
  },
  version: {
    id: "reports.permissionsReport.table.column.version",
    defaultMessage: "Version",
    description: "Permissions Report column - the rep's app version",
  },
});
